module.exports = __webpack_public_path__ + "static/img/celoscope-detail-7.7a47709.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/celoscopepic/celoscope-detail-7.jpg
// module id = RWbc
// module chunks = 51